import React from 'react';
import Dialogue from 'components/UI/Dialogue/Dialogue';

const DeletePostDialogue = (props) => {
  return (
    <Dialogue
      subject="DELETE POST"
      message="Are you sure you want to DELETE this post? If so, all of this content will be permanently deleted from Riza."
      confirm={props.clicked}
      cancelled={props.cancelled}
      cancelText="Cancel"
      confirmationText="Delete"
      dialogueType="alertDialogue"
      postForm
      className={props.className}
    />
  );
};

export default DeletePostDialogue;
